import { fabric } from "fabric";

/**
 * fabric@5.4.0's fabric.Text.prototype._setTextStyles sets
 * ctx.textBaseline = 'alphabetical', which is not a valid CanvasTextBaseline
 * value (the correct spelling is 'alphabetic') and logs a console warning on
 * every text render. Patch it in place rather than editing node_modules,
 * since that gets wiped on reinstall.
 */
if (fabric.Text && fabric.Text.prototype._setTextStyles) {
    const original = fabric.Text.prototype._setTextStyles;
    fabric.Text.prototype._setTextStyles = function (ctx, charStyle, forMeasuring) {
        original.call(this, ctx, charStyle, forMeasuring);
        if (ctx.textBaseline === 'alphabetical') {
            ctx.textBaseline = 'alphabetic';
        }
    };
}
